import React from 'react';

import { marketingCmsClient } from 'src/lib/contentful-client';
import { ContentfulTemplates, isTesting } from 'src/lib/constants';
import { TemplateSwitch } from 'src/templates';

import { optimizeContentfulImages } from 'src/lib/image-helpers';

const Event = (props) => {
  return <TemplateSwitch {...props} />;
};

export async function getStaticPaths() {
  // https://www.contentful.com/developers/docs/references/content-delivery-api/#/reference/entries
  let entries;
  try {
    entries = await marketingCmsClient.getEntries({
      content_type: ContentfulTemplates.EVENT,
    });
  } catch (e) {
    throw new Error(e);
  }

  const paths = entries.items.reduce((pagePaths, entry) => {
    if (entry.fields.pageSlug) {
      pagePaths.push({
        params: {
          id: entry.fields?.locale?.toLowerCase(),
          event: entry.fields.pageSlug,
        },
      });
    }
    return pagePaths;
  }, []);
  return {
    paths: isTesting ? [] : paths,
    fallback: false,
  };
}

export async function getStaticProps({ params, preview }) {
  // https://www.contentful.com/developers/docs/references/content-delivery-api/#/reference/entries
  let legacyEvent, legacyEvents, web2Event;
  try {
    legacyEvent = marketingCmsClient.getEntries({
      content_type: ContentfulTemplates.EVENT,
      include: 10,
      'fields.pageSlug': params.event,
    });

    legacyEvents = marketingCmsClient.getEntries({
      content_type: ContentfulTemplates.EVENT,
      limit: 10,
      'fields.pageSlug[ne]': params.event, // inequality operator - https://www.contentful.com/developers/docs/references/content-delivery-api/#/reference/search-parameters/inequality-operator/query-entries/console/js
      order: ['fields.startTime'],
    });

    web2Event = marketingCmsClient.getEntries({
      content_type: ContentfulTemplates.PAGE,
      include: 10,
      limit: 1000,
      'fields.url[in]': [params.event],
      locale: 'en-US',
    });

    [legacyEvent, legacyEvents, web2Event] = await Promise.all([
      legacyEvent,
      legacyEvents,
      web2Event,
    ]);

    legacyEvent = legacyEvent.items[0];
    legacyEvents = legacyEvents.items;

    web2Event = web2Event?.items?.find((entry) => {
      const url = entry?.fields?.url;
      if (url.length === 2) {
        return url[0] === 'events' && url[1] === params.event;
      }
      return false;
    });
  } catch (e) {
    throw new Error(e);
  }

  const data = web2Event || {
    ...legacyEvent,
    events: [...legacyEvents],
  };

  return {
    props: {
      ...optimizeContentfulImages(data),
      preview: !!preview,
    },
  };
}

export default Event;
